export const MAIN = '/'
export const LOGIN = '/login'
export const LOGOUT = '/logout'
export const NOT_FOUND = '/not-found'
export const DASHBOARD = '/dashboard'
export const SYSTEM = '/system'
